import React from 'react';
import { Box, Typography } from '@mui/material';

interface Props {
	title: string;
	center?: boolean;
	nomargin?: boolean;
}

export const PageTitle = ({ title, center = false, nomargin = false }: Props) => {
	return (
		<Box mb={nomargin ? 0 : 4}>
			<Typography
				id="page-title"
				component="h1"
				variant="h1"
				align={center ? 'center' : 'left'}
			>
				{title}
			</Typography>
		</Box>
	);
};
